import React from "react";
import Layout from "../components/Layout";
import IndividualScoreEntry from "./score/IndividualScoreEntry";
import BetterBallScoreEntry from "./score/BetterBallScoreEntry";
import TeamSingleBallScoreEntry from "./score/TeamSingleBallScoreEntry";
import MatchPlayScoreEntry from "./score/MatchPlayScoreEntry";
import TeamAggregateScoreEntry from "./score/TeamAggregateScoreEntry";
import { useState, useEffect } from "react";
import api from "../api";

// Type 1 — Individual
const INDIVIDUAL = ["Singles Stableford", "Singles Stableford (Full Handicap)", "Singles Medal", "Singles Stroke Play", "Skins"];

// Type 2 — Better Ball
const BETTER_BALL = ["Better Ball Stableford", "Fourball Better Ball Stableford", "Better Ball Medal", "Better Ball Stroke Play", "Fourball Stroke Play"];

// Type 3A — Team Aggregate
const TEAM_AGGREGATE = ["Team Stableford", "Team Medal", "Team Aggregate Stableford", "Team Aggregate Stroke Play"];

// Type 3B — Texas Scramble (handled inside TeamAggregateScoreEntry via isScramble flag)
const TEXAS_SCRAMBLE = ["Texas Scramble", "Texas Scramble (4 players)", "Texas Scramble (3 players)", "Texas Scramble Medal (4 players)", "Texas Scramble Medal (3 players)"];

// Type 4 — Alternate Shot
const ALTERNATE_SHOT = ["Foursomes Stableford", "Foursomes Medal", "Greensomes Stableford", "Greensomes Medal"];

// Type 5 — Match Play
// Singles Match Play removed 2026-09-04 — Mike wants no opponent-pairing
// concept for it at all ("the clue is in the word SINGLE"); it now falls
// through to the default IndividualScoreEntry, exactly like Singles
// Stableford — a flat list, every player enters their own score.
const MATCH_PLAY = ["Better Ball Match Play", "Fourball Match Play", "Foursomes Match Play", "Greensomes Match Play", "Team Match Play"];

export default function ScoreEntry() {
  const [gameType, setGameType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/events/current").then(res => {
      if (res.data) setGameType(res.data.game_type || "");
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div className="p-4 text-gray-500">Loading...</div></Layout>;
  if (!gameType) return <Layout><div className="p-4 text-red-500">No active event. Go to Players screen first.</div></Layout>;

  if (MATCH_PLAY.includes(gameType)) return <MatchPlayScoreEntry />;
  if (BETTER_BALL.includes(gameType)) return <BetterBallScoreEntry />;
  if (ALTERNATE_SHOT.includes(gameType)) return <TeamSingleBallScoreEntry />;
  if (TEAM_AGGREGATE.includes(gameType)) return <IndividualScoreEntry />;
  if (TEXAS_SCRAMBLE.includes(gameType)) return <TeamAggregateScoreEntry />;
  return <IndividualScoreEntry />;
}
